import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';

dayjs.extend(isSameOrAfter);

export const JULY_2026_CONTENT_EFFECTIVE_DATE = '2026-07-01';

export function isJuly2026ContentEffective(): boolean {
  return dayjs().isSameOrAfter(JULY_2026_CONTENT_EFFECTIVE_DATE, 'day');
}
